/**
 * Created by wang on 2017/10/25.
 */
import Vue from 'vue'

let bus = new Vue()

export default bus
